import React from 'react';

interface DifficultyFilterProps {
  selectedDifficulty: string | null;
  onDifficultyChange: (difficulty: string | null) => void;
}

export default function DifficultyFilter({ selectedDifficulty, onDifficultyChange }: DifficultyFilterProps) {
  return (
    <div className="mb-6">
      <label htmlFor="difficulty" className="block text-sm font-medium text-gray-700 mb-2">
        Filter by Difficulty
      </label>
      <select
        id="difficulty"
        value={selectedDifficulty || ''}
        onChange={(e) => onDifficultyChange(e.target.value || null)}
        className="w-full max-w-xs rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500"
      >
        <option value="">All Difficulties</option>
        <option value="beginner">Beginner</option>
        <option value="intermediate">Intermediate</option>
        <option value="advanced">Advanced</option>
      </select>
    </div>
  );
}